import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class SearchOptionsConstants {
    static REMOVE_TITLE = `${SharedConstants.REMOVE_TITLE} search option`;
    static REMOVE_CONTENT = `${SharedConstants.REMOVE_MESSAGE} search option(s)?`;
    static RESET_TO_DEFAULT_MESSAGE = `Are you sure you want to reset the default column list for this search option?`;
    static EDIT_TITLE = "Edit search option columns";
    static ADD_TITLE = "Add search option";
    static SEARCH_OPTION_FORM_CONTROL = "searchOption";
    static SEARCH_COLUMNS_FORM_CONTROL = "searchColumns";
    static SEARCH_OPTION_TEXT = "Search option";
    static SEARCH_OPTION_PLACEHOLDER = "Select a search option type";
    static SORT_FIELD_LIST = "Sort list";
    static MODULE_ID_FILTER_STRING = "moduleId eq";
    static SEARCH_OPTIONS_ORDERBY = "searchOption,moduleField/tableAlias,moduleField/fieldAlias";
    static SEARCH_OPTIONS_COLUMNS_ORDERBY = "columnOrder,moduleField/fieldAlias";
    static DUPLICATE_ITEMS_MESSAGE = "A search option with the provided name already exists. Please select a different search option";
    static SEARCH_OPTIONS_EXPAND = "moduleField";
    static GET_ALL_SEARCH_OPTIONS_PARAM = "searchOption=*";
    static REFRESH_FIELDLIST = "Refresh column list";
    static RESET_TO_DEFAULT = "Reset to default columns";
    static REFRESH_SUCCESS = "Column list has been refreshed";
    static MODIFY_SEARCH_OPTION_CONTENT = "The existing settings for '{existing}' will be removed and settings for '{new}' will be added. Are you sure you want to proceed?";
    static MODIFY_SEARCH_OPTION_TITLE = "Modify search option settings?";
}
export const validationMessage = {
    searchOption: {
        required: `Search option type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
};
